import React from "react"
import { Link } from "gatsby"
import { Box, Flex } from "theme-ui"
import styled from "@emotion/styled"
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share"
import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF"
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter"
import { FaLinkedinIn } from "@react-icons/all-files/fa/FaLinkedinIn"
import { FaWhatsapp } from "@react-icons/all-files/fa/FaWhatsapp"
import { useBreakpointIndex } from "@theme-ui/match-media"

const ButtonShare = styled(Box)`
    margin: 1rem;
    & a {
        margin-top: 0.5rem;
        padding: 0.5rem 1.7rem;
        color: #ffffff;
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }
    & .facebook {
        background: #4267b2;
    }
    & .twitter {
        background: #1da1f2;
    }
    & .linked-in {
        background: #0072b1;
    }
    & .whatsapp {
        background: #25d366;
        padding-top: 1rem;
        padding-bottom: 0;
    }
`

// markup
const IndexPage = ({ pathname, url }) => {
    const breakpoint = useBreakpointIndex()
    let responsive = null
    if (breakpoint <= 3) {
        responsive = {
            flexDirection: "column",
            justifyContent: "center",
        }
    }
    return (
        <Flex sx={responsive}>
            <Box>
                <FacebookShareButton
                    url={url}
                    quote="Careers"
                    className="Demo__some-network__share-button"
                >
                    <ButtonShare>
                        <Link to={pathname} className="facebook">
                            <FaFacebookF /> Share
                        </Link>
                    </ButtonShare>
                </FacebookShareButton>
            </Box>
            <Box>
                <TwitterShareButton
                    url={url}
                    quote="Careers"
                    className="Demo__some-network__share-button"
                >
                    <ButtonShare>
                        <Link to={pathname} className="twitter">
                            <FaTwitter /> Tweet
                        </Link>
                    </ButtonShare>
                </TwitterShareButton>
            </Box>
            <Box>
                <LinkedinShareButton
                    url={url}
                    quote="Careers"
                    className="Demo__some-network__share-button"
                >
                    <ButtonShare>
                        <Link to={pathname} className="linked-in">
                            <FaLinkedinIn /> Share
                        </Link>
                    </ButtonShare>
                </LinkedinShareButton>
            </Box>
            <Box>
                <WhatsappShareButton
                    url={url}
                    quote="Careers"
                    className="Demo__some-network__share-button"
                >
                    <ButtonShare>
                        <Link to={pathname} className="whatsapp">
                            <FaWhatsapp size={25} />
                        </Link>
                    </ButtonShare>
                </WhatsappShareButton>
            </Box>
        </Flex>
    )
}

export default IndexPage
